type Props = {
  className?: string;
};

const IconCloseModal = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M5 5.5L19 19.5M5 19.5L19 5.5"
      stroke="#BEBEBE"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconCloseModal;
